<nav class="navbar navbar-expand-lg navbar-light bg-faded">
    <div class="container-fluid">
        <div class="navbar-header">
            <button type="button" class="navbar-toggle d-lg-none float-left" data-toggle="collapse">
                <span class="sr-only">Toggle navigation</span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
            </button>
        </div>
        <div class="navbar-container">
            <div class="navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav">
                    <li class="nav-item mr-2">
                        <a href="javascript:;" class="nav-link" appToggleFullscreen>                            
                            <i class="ft-maximize font-medium-3 blue-grey darken-4" style="vertical-align: middle;"></i>
                            <p class="d-none">fullscreen</p>
                        </a>
                    </li>
                    <li class="nav-item mr-2" ngbDropdown placement="bottom-right">
                        <a class="nav-link position-relative" id="navbarUserSettings" ngbDropdownToggle>
                            {{languages[translate.currentLang]}}
                        </a>
                        <div ngbDropdownMenu aria-labelledby="dropdownBasic3">
                            <a class="dropdown-item py-1" *ngFor="let lang of translate.getLangs()" (click)="changeLanguage(lang)" [ngStyle]="{'opacity': lang === translate.currentLang ? '1.0': '0.5'}">
                                <span id="navbarUsername">{{languages[lang]}}</span>
                            </a>
                        </div>
                    </li>
                    <li class="nav-item" ngbDropdown placement="bottom-right">
                        <a class="nav-link position-relative" id="navbarUserSettings" ngbDropdownToggle>
                            <i class="ft-user font-medium-3 blue-grey darken-4" style="vertical-align: middle;"></i>
                            <p class="d-none">User Settings</p>
                        </a>
                        <div ngbDropdownMenu aria-labelledby="dropdownBasic3">
                            <a *ngIf="currentUser" class="dropdown-item py-1" href="javascript:;">
                                <span id="navbarUsername">{{currentUser.email}}</span>
                            </a>
                            <div *ngIf="currentUser" class="dropdown-divider"></div>
                            <a *ngIf="currentUser" class="dropdown-item py-1" [routerLink]="['/profile']">
                                <i class="ft-edit mr-2"></i>
                                <span>{{'profile' | translate}}</span>
                            </a>
                            <a *ngIf="currentUser && (currentUser.isAdminGlobal || currentUser.temporaryUserId)" class="dropdown-item py-1" (click)="browseAs(currentUser.temporaryUserId || currentUser.id)">
                                <i class="ft-user mr-2"></i>
                                <span>Session zurücksetzen</span>
                            </a>
                            <a *ngIf="!currentUser" class="dropdown-item py-1" (click)="browseAs('none')">
                                <i class="ft-user mr-2"></i>
                                <span>Session zurücksetzen</span>
                            </a>
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item" [routerLink]="'/login'">
                                <i class="ft-power mr-2"></i>
                                <span>{{'logout' | translate}}</span>
                            </a>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</nav>


// WEBPACK FOOTER //
// ./src/app/shared/navbar/navbar.component.html